import { createSlice } from '@reduxjs/toolkit';
import { clearReducers } from 'redux/logout';

export const initialState = {
  items: [],
  destinyID: null,
  originID: null,
  removePacketID: null,
  departureType: null,
  search: '',
  pageable: {
    pageNumber: 0,
    pageSize: 10,
  },
  loaded: false,
};

const packageLogisticOperatorDepartureSlice = createSlice({
  name: 'packageLogisticOperatorDeparture',
  initialState,
  reducers: {
    // El listado es local (memoria + localStorage), no hay fetch: apenas se
    // monta la pantalla ya está listo para mostrarse.
    initial: (state) => {
      state.loaded = true;
    },
    success: (state, action) => {
      state.loaded = true;
      state.items = action.payload;
    },
    failure: (state) => {
      state.loaded = true;
    },
    dispatchPackages: (state) => {
      state.loaded = false;
    },
    dispatchPackagesSuccess: (state) => {
      state.loaded = true;
    },
    removePacket: (state, action) => {
      state.removePacketID = action.payload;
    },
    removePacketSuccess: (state, action) => {
      state.items = state.items.filter((item) => item.id !== action.payload);
    },
    assignPacket: (state, action) => {
      state.assignPacketID = action.payload;
    },
    updatePackets: (state, action) => {
      state.items = action.payload;
    },
    addPackage: (state, action) => {
      state.items.unshift(action.payload);
    },
    updatePageable: (state, action) => {
      state.pageable.pageNumber =
        action.payload.pageSize !== state.pageable.pageSize
          ? 0
          : action.payload.pageNumber;
      state.pageable.pageSize = action.payload.pageSize;
    },
    updateOrigin: (state, action) => {
      state.originID = action.payload;
    },
    updateDestiny: (state, action) => {
      state.destinyID = action.payload;
    },
    updateDepartureType: (state, action) => {
      state.destinyID = null;
      state.departureType = action.payload;
    },
    updateSearch: (state, action) => {
      state.pageable.pageNumber = 0;
      state.search = action.payload;
    },
    resetRemovePacketID: (state) => {
      state.removePacketID = initialState.removePacketID;
    },
    resetFilters: (state) => {
      state.search = initialState.search;
      state.pageable = initialState.pageable;
    },
    reset: (state) => {
      state.items = initialState.items;
    },
  },
  extraReducers: {
    [clearReducers]: () => initialState,
  },
});

export const { name, reducer, actions } = packageLogisticOperatorDepartureSlice;
